"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Pager_native_exports = {};
__export(Pager_native_exports, {
  Pager: () => Pager
});
module.exports = __toCommonJS(Pager_native_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_OneNativePagerNativeComponent = __toESM(require("../specs/OneNativePagerNativeComponent"), 1);
var import_pagerTypes = require("./pagerTypes");
var Pager = /* @__PURE__ */ (0, import_react.forwardRef)(function Pager2(param, ref) {
  var { children, onPageScrollStateChanged, ...props } = param;
  (0, import_pagerTypes.validatePager)(props);
  var nativeRef = (0, import_react.useRef)(null);
  (0, import_react.useImperativeHandle)(ref, function() {
    return {
      setPage(index) {
        (0, import_pagerTypes.validatePage)(index);
        if (nativeRef.current) import_OneNativePagerNativeComponent.Commands.setPage(nativeRef.current, index);
      },
      setPageWithoutAnimation(index) {
        (0, import_pagerTypes.validatePage)(index);
        if (nativeRef.current) import_OneNativePagerNativeComponent.Commands.setPageWithoutAnimation(nativeRef.current, index);
      },
      setScrollEnabled(enabled) {
        if (nativeRef.current) import_OneNativePagerNativeComponent.Commands.setScrollEnabledImperatively(nativeRef.current, enabled);
      }
    };
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_OneNativePagerNativeComponent.default, {
    ...props,
    ref: nativeRef,
    onPageScrollStateChanged: onPageScrollStateChanged ? function(param2) {
      var { nativeEvent } = param2;
      var state = nativeEvent.pageScrollState;
      if (state === "idle" || state === "dragging" || state === "settling") onPageScrollStateChanged({
        nativeEvent: {
          pageScrollState: state
        }
      });
    } : void 0,
    children: import_react.Children.map(children, function(child) {
      if (!/* @__PURE__ */ (0, import_react.isValidElement)(child)) throw new Error("Pager children must be React Native views");
      return /* @__PURE__ */ (0, import_react.cloneElement)(child, {
        collapsable: false,
        style: [
          child.props.style,
          {
            position: "absolute",
            width: "100%",
            height: "100%"
          }
        ]
      });
    })
  });
});
//# sourceMappingURL=Pager.native.js.map
